var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.012,
    height: 16.955,
    viewBox: "0 0 22.012 16.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3_User",
    "data-name": "3 User",
    transform: "translate(0.063 0.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,6.553A.75.75,0,0,1-.75,5.8.75.75,0,0,1,0,5.053,2.154,2.154,0,0,0,2.152,2.9,2.154,2.154,0,0,0,0,.75.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75,3.656,3.656,0,0,1,3.652,2.9,3.656,3.656,0,0,1,0,6.553Z",
    transform: "translate(16.595 1.129)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.422,4.1a.75.75,0,0,1-.15-1.485c.94-.193,1.146-.486,1.186-.571a.628.628,0,0,0,0-.54c-.11-.23-.551-.441-1.179-.564l-.021,0A8.716,8.716,0,0,0-.052.748a.75.75,0,0,1-.7-.8.75.75,0,0,1,.8-.7,10.224,10.224,0,0,1,1.526.221A2.9,2.9,0,0,1,3.812.861a2.123,2.123,0,0,1,0,1.829,2.934,2.934,0,0,1-2.239,1.4A.753.753,0,0,1,1.422,4.1Z",
    transform: "translate(17.929 10.085)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M2.9,6.553a3.651,3.651,0,1,1,0-7.3.75.75,0,0,1,.75.75A.75.75,0,0,1,2.9.75a2.151,2.151,0,1,0,0,4.3.75.75,0,0,1,0,1.5Z",
    transform: "translate(2.388 1.129)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M1.846,4.1a.753.753,0,0,1-.152-.016A2.93,2.93,0,0,1-.544,2.69a2.115,2.115,0,0,1,0-1.829A2.892,2.892,0,0,1,1.691-.528,10.225,10.225,0,0,1,3.217-.748a.75.75,0,0,1,.8.7.75.75,0,0,1-.7.8,8.718,8.718,0,0,0-1.31.19l-.021,0c-.931.182-1.137.478-1.178.564a.623.623,0,0,0,0,.539c.041.086.245.378,1.185.572A.75.75,0,0,1,1.846,4.1Z",
    transform: "translate(0.688 10.085)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M6.021-.75a14.539,14.539,0,0,1,4.466.53c1.9.639,2.3,1.808,2.3,2.677s-.4,2.04-2.294,2.685a14.368,14.368,0,0,1-4.476.54,14.539,14.539,0,0,1-4.467-.53c-1.9-.639-2.3-1.808-2.3-2.677S-.352.435,1.544-.21A14.373,14.373,0,0,1,6.021-.75Zm0,4.932a13.194,13.194,0,0,0,3.993-.461c1.277-.434,1.277-1.037,1.277-1.264s0-.825-1.281-1.255A13.37,13.37,0,0,0,6.021.75a13.2,13.2,0,0,0-3.993.46C.75,1.644.75,2.248.75,2.475S.75,3.3,2.031,3.73A13.37,13.37,0,0,0,6.021,4.182Z",
    transform: "translate(4.917 10.71)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M3.858,8.467A4.6,4.6,0,0,1-.75,3.858,4.595,4.595,0,0,1,3.858-.75,4.595,4.595,0,0,1,8.467,3.858,4.6,4.6,0,0,1,3.858,8.467Zm0-7.717A3.109,3.109,0,1,0,6.967,3.858,3.112,3.112,0,0,0,3.858.75Z",
    transform: "translate(7.079 0.188)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.bb98a1b3f6a46d8f83cd2d49df39741b.svg";
export { ForwardRef as ReactComponent };